import { z } from 'zod'
import { CATEGORY_MAX_LENGTH, NOTICE_CATEGORY, TITLE_MAX_LENGTH } from '../consts'

/** Quill 이 비운 본문은 `<p><br></p>` 다 — 태그를 걷고 글자가 남는지 본다. */
export const isBlankHtml = (html: string): boolean => html.replace(/<[^>]*>/g, '').replace(/&nbsp;/g, ' ').trim() === ''

export const boardFormSchema = z
  .object({
    category: z.string().min(1, '분류를 선택해 주세요.').max(CATEGORY_MAX_LENGTH),
    title: z.string().trim().min(1, '제목을 입력해 주세요.').max(TITLE_MAX_LENGTH, `제목은 ${TITLE_MAX_LENGTH}자까지 입력할 수 있습니다.`),
    content: z.string().refine((v) => !isBlankHtml(v), '내용을 입력해 주세요.'),
    /** 공지 대상(등록만) — `ALL` 또는 화주 코드 */
    noticeTarget: z.string().optional(),
    /** 수정이면 공지 대상을 보내지 않는다(서버가 화주를 바꾸지 않는다). */
    isEdit: z.boolean(),
  })
  .refine((v) => v.isEdit || v.category !== NOTICE_CATEGORY || !!v.noticeTarget, { path: ['noticeTarget'], message: '공지사항 대상을 선택해 주세요.' })

export type BoardFormValues = z.infer<typeof boardFormSchema>
